module.exports = __webpack_public_path__ + "img/bRem.27e2bf66.svg";